import styled from 'styled-components';

export const h1 = styled.h1`
  font-family: Manrope;
  font-style: normal;
  font-size: 36px;
  line-height: 54px;
  font-weight: 600;
  margin-bottom: 40px;
`

export const h2 = styled.h2`
  font-family: Manrope;
  font-style: normal;
  font-size: 28px;
  line-height: 40px;
  font-weight: 600;
  text-transform: none;
`

export const h3 = styled.h3`
  text-transform: none;
  font-family: Manrope;
  font-style: normal;
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
`

export const h4 = styled.h4`
  text-transform: none;
  font-family: Manrope;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`

export const h5 = styled.h5`
  text-transform: none;
  font-family: Manrope;
  font-style: normal;
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
`